var setHeightOfTextArea = function (ele) {
    // We need to reset the height momentarily to get the correct scrollHeight for the textarea
    ele.style.height = "0px";
    var scrollHeight = ele.scrollHeight;
    // We then set the height directly, outside of the render loop.
    // Trying to set this with state will produce an incorrect value.
    ele.style.height = scrollHeight + "px";
};

export { setHeightOfTextArea };
//# sourceMappingURL=TextAreaWithAutoHeight.js.map
